import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getGradeObject'
})
export class GetGradeByNamePipe implements PipeTransform {
    transform(grade: string): any {
        let grades: any[] = [
            { ID: 1, GRADES: 'P0' },
            { ID: 2, GRADES: 'P1' },
            { ID: 3, GRADES: 'P2' },
            { ID: 4, GRADES: 'P3' },
            { ID: 5, GRADES: 'P4' },
            { ID: 6, GRADES: 'P5' },
            { ID: 7, GRADES: 'P6' },
            { ID: 8, GRADES: 'K' },
            { ID: 9, GRADES: '01' },
            { ID: 10, GRADES: '02' },
            { ID: 11, GRADES: '03' },
            { ID: 12, GRADES: '04' },
            { ID: 13, GRADES: '05' },
            { ID: 14, GRADES: '06' },
            { ID: 15, GRADES: '07' },
            { ID: 16, GRADES: '08' },
            { ID: 17, GRADES: '09' },
            { ID: 18, GRADES: '10' },
            { ID: 19, GRADES: '11' },
            { ID: 20, GRADES: '12' },
            { ID: 21, GRADES: 'UG' },
            { ID: 22, GRADES: 'AD' },
            { ID: 23, GRADES: 'NA' },
            { ID: 86, GRADES: 'PK' },
            { ID: 87, GRADES: 'TK' }
        ];
        let foundGrade: any;

        foundGrade = grades.find((g: any) => g.GRADES === grade);

        return foundGrade;
    }
}
